import React from 'react'
import { Alert, Flex, Modal, Spin, Typography } from 'antd'
import { useUnit } from 'effector-react'
import {
  $addressErrorMessage,
  $checkAddressResult,
  addressCheckRefreshRequested,
  checkAddressFx,
  refreshAddressCheckFx,
} from '../check/model'
import { AddressResult } from '../check/widgets/AddressResult'
import { $checkedWallet, walletCheckClosed } from './model'
import { getWalletName } from './wallets'

export const WGDashboardWalletCheckModal = () => {
  const {
    wallet,
    result,
    errorMessage,
    loading,
    refreshing,
    onRefresh,
    onClose,
  } = useUnit({
    wallet: $checkedWallet,
    result: $checkAddressResult,
    errorMessage: $addressErrorMessage,
    loading: checkAddressFx.pending,
    refreshing: refreshAddressCheckFx.pending,
    onRefresh: addressCheckRefreshRequested,
    onClose: walletCheckClosed,
  })

  return (
    <Modal
      open={wallet !== null}
      title="Ручная проверка кошелька"
      footer={null}
      onCancel={() => onClose()}
    >
      {wallet && (
        <Flex vertical gap={16}>
          <Flex vertical gap={4}>
            <Typography.Text strong>
              {getWalletName(wallet.name, wallet.address)}
            </Typography.Text>
            <Typography.Text type="secondary" copyable>
              {wallet.address}
            </Typography.Text>
            <Typography.Text type="secondary">
              Сеть: {wallet.network}
            </Typography.Text>
          </Flex>

          {loading && <Spin />}

          {errorMessage && (
            <Alert type="error" showIcon message={errorMessage} />
          )}

          {result && (
            <AddressResult
              check={result}
              refreshing={refreshing}
              hasError={errorMessage !== null}
              onRefresh={() => onRefresh(result)}
            />
          )}
        </Flex>
      )}
    </Modal>
  )
}
